import { createActions } from '@/utils/actions';

import scheduleListings from './schedule.listings';
import scheduleUpdates from './schedule.updates';

const { actions: schedule } = createActions('schedule')
  .add('bootstrap')
  .addAsync('getCounts')
  .add('cleanUp');

schedule.listings = scheduleListings;
schedule.updates = scheduleUpdates;

export default schedule;
